import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, unref as _unref, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  class: "bg-warning-light p-8"
};
const _hoisted_2 = {
  class: "flex items-center space-x-4"
};
const _hoisted_3 = {
  class: "w-9/12"
};
const _hoisted_4 = {
  key: 1,
  "data-cy": "user-email"
};
const _hoisted_5 = {
  class: "flex items-center space-x-4"
};
const _hoisted_6 = {
  class: "w-9/12"
};
const _hoisted_7 = {
  class: "flex items-center space-x-4"
};
const _hoisted_8 = {
  class: "w-9/12"
};
const _hoisted_9 = {
  class: "flex items-center space-x-4"
};
const _hoisted_10 = {
  class: "w-3/12 pr-4"
};
const _hoisted_11 = {
  class: "text-left"
};
const _hoisted_12 = {
  class: "w-9/12"
};
const _hoisted_13 = {
  class: "flex items-center space-x-4"
};
const _hoisted_14 = {
  class: "w-3/12 pr-4"
};
const _hoisted_15 = {
  class: "text-left"
};
const _hoisted_16 = {
  class: "w-9/12"
};
const _hoisted_17 = {
  class: "flex items-center space-x-4"
};
const _hoisted_18 = {
  class: "w-9/12"
};
const _hoisted_19 = {
  class: "flex items-center space-x-4"
};
const _hoisted_20 = {
  class: "w-9/12"
};
const _hoisted_21 = {
  class: "flex items-center space-x-4"
};
const _hoisted_22 = {
  class: "w-3/12 pr-4"
};
const _hoisted_23 = {
  class: "text-left"
};
const _hoisted_24 = {
  class: "w-9/12"
};
const _hoisted_25 = {
  class: "flex items-center space-x-4"
};
const _hoisted_26 = {
  class: "w-3/12 pr-4"
};
const _hoisted_27 = {
  class: "text-left"
};
const _hoisted_28 = {
  class: "w-9/12"
};
const _hoisted_29 = {
  key: 0,
  class: "w-full text-left text-sm text-gray-500"
};
const _hoisted_30 = {
  class: "flex items-center space-x-4"
};
const _hoisted_31 = {
  class: "w-9/12"
};
const _hoisted_32 = {
  class: "flex items-center space-x-4"
};
const _hoisted_33 = {
  class: "w-9/12"
};
const _hoisted_34 = {
  key: 0
};
import { storeToRefs } from 'pinia';
import Loader from '@/components/Loader.vue';
import LlTextField from '@/components/LlTextField.vue';
import LlSelect from '@/components/LlSelect.vue';
import LlCheckbox from '@/components/LlCheckbox.vue';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import LlTooltip from '@/components/LlTooltip.vue';
import { computed, onMounted, reactive, ref } from 'vue';
import { useMeStore } from '@/services/UserService/useMeStore';
import ListsService from '@/services/ListsService';
import { useAccountsStore } from '@/services/UserService/useAccountsStore';
import { useCompanyBillingStore } from '@/modules/settings/integrations/QBO/companyBillingStore';
import EditUserRate from './EditUserRate.vue';
import { useSnackbarHandler } from '@/composables/useSnackbarHandler';
import SnackbarComponent from '@/components/SnackbarComponent.vue';
import { useCompanyStore } from '@/services/UserService/useCompanyStore';
import LlConfirmationDialog from '@/components/LlConfirmationDialog.vue';
import { isValidSingleEmail } from '@/services/utils';
export default {
  __name: 'CompanyUserInfo',
  props: {
    type: {
      type: String,
      required: true
    },
    userInfo: {
      type: Object,
      default: () => ({}),
      required: true
    }
  },
  emits: ['confirm', 'cancel'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const zeroRateAlert = ref(undefined);
    const confirmationDialog = ref(null);
    const handleConfirmCallback = ref(() => {});
    const handleCancelCallback = ref(() => {});
    const emit = __emit;
    const dialogOptions = ref({
      title: '',
      message: '',
      confirmText: 'Confirm',
      cancelText: 'Cancel'
    });
    const {
      getMe
    } = useMeStore();
    const {
      me,
      terms,
      features
    } = storeToRefs(useMeStore());
    const companyBillingStore = useCompanyBillingStore();
    const listsService = new ListsService();
    const accountsStore = useAccountsStore();
    const {
      handleError,
      handleWarning
    } = useSnackbarHandler();
    const {
      companySettings
    } = storeToRefs(useCompanyStore());
    const isFormValid = ref(false);
    const userForm = ref(null);
    const validationRules = {
      required: value => !!value || 'This field is required.',
      email: [value => !!value || 'Email is required.', value => isValidSingleEmail(value) || 'Enter a valid email address.', value => value.length <= 254 || 'Email cannot exceed 254 characters.']
    };
    const rateRules = computed(() => {
      if (props.type !== 'accountant') {
        return [v => !!v || `User's rate cannot be left blank`, v => v >= 0 || `User's rate cannot be negative`];
      }
      return []; // No rules for accountants
    });
    const companyUserInfoModal = reactive({
      isUserInvited: false,
      loading: false,
      accountList: [],
      roles: [],
      roleDescription: '',
      form: {
        email: '',
        firstName: '',
        lastName: '',
        initials: '',
        ledesInitials: '',
        distributionCategory: {
          id: '',
          label: 'Select Distribution Category'
        },
        standardRate: null,
        role: '',
        accessToFirmSetup: false,
        ccResponsibleInvoices: false,
        ccMeOnInvoicesByDefault: false,
        includeOnAllMatters: props.userInfo.access?.include || false,
        rates: {},
        invoiceClass: null
      },
      isSaving: false,
      showEditRateModal: false,
      showZeroRateConfirmationModal: false,
      saveWithZeroRate: false,
      selectedUserData: {},
      invoiceClassTags: [],
      subscriptionCost: {},
      subscriptionCostLoading: false,
      accountState: {},
      confirmExternalUser: false
    });
    onMounted(async () => {
      companyUserInfoModal.loading = true;
      const backgroundAPICalls = [getMe(), companyBillingStore.listAccountingAccounts()];
      if (companySettings.value?.tags?.enabled) {
        backgroundAPICalls.push(accountsStore.listInvoiceClassTags());
      }
      const [, accountList, tags = []] = await Promise.all(backgroundAPICalls);
      companyUserInfoModal.accountList = combineAccounts(accountList);
      if (tags.length) {
        companyUserInfoModal.invoiceClassTags = tags;
      }
      if (props.type === 'accountant') {
        companyUserInfoModal.form.role = 'Accountant';
        companyUserInfoModal.form.accessToFirmSetup = true;
      }
      initializeCompanyUserInfo();
    });
    const initializeCompanyUserInfo = async () => {
      try {
        loadRoles();
        if (props.userInfo.id) {
          await loadUserData(props.userInfo.id);
        }
      } catch (error) {
        handleError(error);
      } finally {
        companyUserInfoModal.loading = false;
      }
    };
    const loadRoles = () => {
      companyUserInfoModal.roles = props.userInfo.role !== 'accountant' ? listsService.getUserRoles('ledes1998').filter(role => role.id !== 'accountant') : listsService.getUserRoles('ledes1998');
    };
    const combineAccounts = accountList => {
      return companyBillingStore.combineQuickBooksAccounts(accountList, ['asset', 'expense', 'liability', 'income']);
    };
    const loadUserData = async userId => {
      try {
        companyUserInfoModal.loading = true;
        const [accountState, selectedUserData] = await Promise.all([accountsStore.getAccountState(userId), accountsStore.getuserAccountDetailsById(userId)]);
        populateUserData(accountState, selectedUserData);
      } finally {
        companyUserInfoModal.loading = false;
      }
    };
    const loadSubscriptionCost = async isDisabled => {
      companyUserInfoModal.subscriptionCostLoading = true;
      try {
        const costParams = isDisabled ? {
          addSeat: 1
        } : {
          removeSeat: 1
        };
        const subscriptionCost = await accountsStore.getSubscriptionCost(costParams);
        companyUserInfoModal.subscriptionCost = subscriptionCost;
      } catch (error) {
        console.error('Error loading subscription cost:', error);
      } finally {
        companyUserInfoModal.subscriptionCostLoading = false;
      }
    };
    const populateUserData = (accountState, selectedUserData) => {
      companyUserInfoModal.accountState = accountState;
      companyUserInfoModal.selectedUserData = selectedUserData;
      const {
        first,
        last,
        email,
        rates,
        access,
        settings,
        ledesInitials,
        initials,
        invitation
      } = selectedUserData || {};
      companyUserInfoModal.form = {
        firstName: first,
        lastName: last,
        email,
        rates,
        standardRate: rates?.standard,
        accessToFirmSetup: access?.setup,
        includeOnAllMatters: access?.include,
        ccResponsibleInvoices: settings?.ccPrimary,
        ccMeOnInvoicesByDefault: settings?.ccMeOnInvoicesByDefault,
        distributionCategory: getDistributionCategoryLabel(settings?.distribution?.account?.id),
        ledesInitials,
        ledesCode1998B: settings?.timeKeeperClassificationLedes,
        ledesCodeNew: settings?.timeKeeperClassificationLedesXml,
        initials,
        role: getRoleLabel(props.userInfo.role),
        invoiceClass: settings?.tag ? {
          id: settings.tag.id,
          label: settings.tag.label
        } : null
      };
      companyUserInfoModal.isUserInvited = invitation;
    };
    const loaderText = computed(() => {
      if (props.type === 'invite' || props.type === 'accountant') {
        return 'User Invitation Form';
      } else {
        return 'User Information';
      }
    });
    const fullName = computed(() => `${companyUserInfoModal?.form?.firstName} ${companyUserInfoModal?.form?.lastName}`);
    const cardTitle = computed(() => props.type === 'invite' ? 'Invite User Form' : props.type === 'accountant' ? 'Add Accounting Partner' : 'Edit User Information');
    const getRoleLabel = roleId => {
      const role = companyUserInfoModal.roles.find(role => role.id === roleId);
      return role?.label || '';
    };
    const getDistributionCategoryLabel = categoryId => {
      const category = companyUserInfoModal.accountList.find(c => c.id === categoryId);
      return category?.label || '';
    };
    const handleRoleChange = value => {
      if (me.value.id !== props.userInfo.id) {
        if (['Principal', 'Operator'].includes(value.label) && !props.userInfo.id) {
          companyUserInfoModal.form.accessToFirmSetup = true;
        } else {
          companyUserInfoModal.form.accessToFirmSetup = false;
        }
      }
      companyUserInfoModal.roleDescription = value ? value.description : '';
    };
    const closeEditRateModal = () => {
      companyUserInfoModal.showEditRateModal = false;
      companyUserInfoModal.selectedUserData = {};
    };
    const save = async () => {
      const missingFields = [];
      await userForm.value.validate();
      const standardRateInput = companyUserInfoModal.form.standardRate;
      const standardRate = parseFloat(standardRateInput);
      if (standardRate === 0 && !companyUserInfoModal.saveWithZeroRate && props.type === 'invite') {
        triggerZeroRateConfirmation();
        return;
      }
      if (!companyUserInfoModal.form.firstName?.trim()) {
        missingFields.push('First Name');
      }
      if (!companyUserInfoModal.form.lastName?.trim()) {
        missingFields.push('Last Name');
      }
      if (!companyUserInfoModal.form.email?.trim()) {
        missingFields.push('Email Address');
      }
      if (!companyUserInfoModal.form.role === 'Accountant' || !companyUserInfoModal.form.role && props.type !== 'accountant') {
        missingFields.push('User Role');
      }
      if (missingFields.length > 0) {
        handleError(`${missingFields.join(', ')} ${missingFields.length > 1 ? 'are' : 'is'} required.`);
        return;
      } else {
        if (props.type === 'accountant' && !companyUserInfoModal.confirmExternalUser) {
          handleWarning('Please confirm that the user is external to the firm in the checkbox above');
          return;
        }
        companyUserInfoModal.isSaving = true;
        try {
          const payload = {
            access: {
              setup: companyUserInfoModal.form.accessToFirmSetup,
              include: companyUserInfoModal.form.includeOnAllMatters
            },
            roles: {},
            email: companyUserInfoModal.form.email,
            first: companyUserInfoModal.form.firstName,
            last: companyUserInfoModal.form.lastName,
            initials: companyUserInfoModal.form.initials,
            ledesInitials: companyUserInfoModal.form.ledesInitials,
            settings: {
              distribution: {
                account: {
                  id: companyUserInfoModal.form.distributionCategory?.id,
                  name: companyUserInfoModal.form.distributionCategory?.name,
                  type: companyUserInfoModal.form.distributionCategory?.type,
                  subtype: companyUserInfoModal.form.distributionCategory?.subtype,
                  balance: companyUserInfoModal.form.distributionCategory?.balance,
                  label: companyUserInfoModal.form.distributionCategory?.label
                }
              },
              timeKeeperClassificationLedes: companyUserInfoModal.form.ledesCode1998B,
              timeKeeperClassificationLedesXml: companyUserInfoModal.form.ledesCodeNew,
              tag: companyUserInfoModal.form.invoiceClass,
              ccMeOnInvoicesByDefault: companyUserInfoModal.form.ccMeOnInvoicesByDefault,
              ccPrimary: companyUserInfoModal.form.ccResponsibleInvoices
            },
            rates: {
              standard: standardRate
            },
            role: companyUserInfoModal.form.role?.id
          };
          if (props.type === 'accountant') {
            payload.role = 'accountant';
          }
          ['invite', 'accountant'].includes(props.type) && (await accountsStore.createAccountAndSendInvitation(payload));
          props.userInfo?.id && (await accountsStore.updateAccount(props.userInfo.id, payload));
          companyUserInfoModal.isSaving = false;
          emit('confirm');
        } catch (error) {
          handleError(error);
        }
      }
    };
    const triggerZeroRateConfirmation = () => {
      companyUserInfoModal.showZeroRateConfirmationModal = true;
      zeroRateAlert.value.open().then(result => {
        if (result) {
          companyUserInfoModal.showZeroRateConfirmationModal = false;
          companyUserInfoModal.saveWithZeroRate = true;
          save();
        } else {
          companyUserInfoModal.showZeroRateConfirmationModal = false;
        }
      });
    };
    const updateUserRate = async rates => {
      companyUserInfoModal.form.standardRate = rates.rateOptions ? rates.rates.standard : rates.standard;
      companyUserInfoModal.form.rates = rates.rateOptions ? rates.rates : rates;
      await accountsStore.updateAccount(props.userInfo.id, rates);
      companyUserInfoModal.showEditRateModal = false;
    };
    const openConfirmationDialog = options => {
      // Set the dialog options dynamically
      dialogOptions.value = {
        title: options.title || '',
        message: options.message || '',
        confirmText: options.confirmText || 'Confirm',
        cancelText: options.cancelText || 'Cancel'
      };

      // action callbacks
      handleConfirmCallback.value = options.onConfirm || (() => {});
      handleCancelCallback.value = options.onCancel || (() => {});
      confirmationDialog.value.open();
    };
    const handleConfirm = () => {
      handleConfirmCallback.value();
    };
    const handleCancel = () => {
      handleCancelCallback.value();
    };
    const enableUser = async () => {
      await loadSubscriptionCost(props.userInfo.disabled);
      openConfirmationDialog({
        title: 'Enable this user?',
        message: `${companyUserInfoModal?.subscriptionCost?.message || ''}. ${companyUserInfoModal?.subscriptionCost?.detail || ''}`.trim(),
        confirmText: 'OK',
        cancelText: 'Cancel',
        onConfirm: async () => {
          companyUserInfoModal.isSaving = true;
          await accountsStore.archiveAccount(companyUserInfoModal.selectedUserData.id, {
            archive: false
          });
          emit('confirm');
        }
      });
    };
    const disableOrRemoveUser = async () => {
      companyUserInfoModal.form.role !== 'Accountant' && (await loadSubscriptionCost(props.userInfo.disabled));
      companyUserInfoModal.accountState?.activity ? disableUser() : removeUser();
    };
    const disableUser = () => {
      const message = `The user's activity (time entries, expenses, or similar) will remain in the system. The user will not be able to log in, and new time entries cannot be created for them, but they will still appear in certain reports.${companyUserInfoModal.form.role !== 'Accountant' ? ` ${companyUserInfoModal?.subscriptionCost?.message || ''} ${companyUserInfoModal?.subscriptionCost?.detail || ''}` : ''}`.trim();
      openConfirmationDialog({
        title: 'Disable this user?',
        message: message,
        confirmText: 'OK',
        cancelText: 'Cancel',
        onConfirm: async () => {
          companyUserInfoModal.isSaving = true;
          await accountsStore.archiveAccount(companyUserInfoModal.selectedUserData.id, {
            archive: true
          });
          emit('confirm');
        }
      });
    };
    const removeUser = () => {
      openConfirmationDialog({
        title: 'Remove this user from your account?',
        message: `This cannot be undone (but we checked that the user doesn't have any activity in the system). ${companyUserInfoModal?.subscriptionCost?.message || ''}. ${companyUserInfoModal?.subscriptionCost?.detail || ''}`.trim(),
        confirmText: 'OK',
        cancelText: 'Cancel',
        onConfirm: async () => {
          companyUserInfoModal.isSaving = true;
          await accountsStore.deleteAccount(companyUserInfoModal.selectedUserData.id, {
            archive: true
          });
          emit('confirm');
        }
      });
    };
    const resetPassword = () => {
      openConfirmationDialog({
        title: 'Reset Password',
        message: `This will reset the user's password and send an invitation email to them. They won't lose their data. Ok to reset their login?`,
        confirmText: 'OK',
        cancelText: 'Cancel',
        onConfirm: async () => {
          companyUserInfoModal.isSaving = true;
          await accountsStore.inviteAccount(companyUserInfoModal.selectedUserData.id, companyUserInfoModal.selectedUserData.email);
          emit('confirm');
        }
      });
    };
    const sendInvite = () => {
      const apiDomain = window.leanlaw.domain;
      const link = `${apiDomain}/account/invite/${companyUserInfoModal.selectedUserData?.invitation?.id}`;
      openConfirmationDialog({
        title: '',
        message: `The invite link for this user is
    ${link}
    Send it to them again? You can also send this link to them by copying it from above.`,
        confirmText: 'OK',
        cancelText: 'Cancel',
        onConfirm: async () => {
          companyUserInfoModal.isSaving = true;
          await accountsStore.inviteAccount(companyUserInfoModal.selectedUserData.id, companyUserInfoModal.selectedUserData.email);
          emit('confirm');
        }
      });
    };
    return (_ctx, _cache) => {
      const _component_v_dialog = _resolveComponent("v-dialog");
      const _component_v_icon = _resolveComponent("v-icon");
      const _component_v_card_title = _resolveComponent("v-card-title");
      const _component_v_col = _resolveComponent("v-col");
      const _component_v_row = _resolveComponent("v-row");
      const _component_v_form = _resolveComponent("v-form");
      const _component_v_card_text = _resolveComponent("v-card-text");
      const _component_v_spacer = _resolveComponent("v-spacer");
      const _component_v_card_actions = _resolveComponent("v-card-actions");
      const _component_v_card = _resolveComponent("v-card");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(SnackbarComponent, {
        ref: "snackbar"
      }, null, 512), companyUserInfoModal.loading ? (_openBlock(), _createBlock(Loader, {
        key: 0,
        what: loaderText.value,
        class: "my-6 px-6 w-100 items-center"
      }, null, 8, ["what"])) : (_openBlock(), _createBlock(_component_v_card, {
        key: 1
      }, {
        default: _withCtx(() => [companyUserInfoModal.showEditRateModal ? (_openBlock(), _createBlock(_component_v_dialog, {
          key: 0,
          modelValue: companyUserInfoModal.showEditRateModal,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => companyUserInfoModal.showEditRateModal = $event),
          width: "400"
        }, {
          default: _withCtx(() => [_createVNode(EditUserRate, {
            userName: fullName.value,
            existingRates: companyUserInfoModal.form.rates,
            rules: [validationRules.required],
            onCancel: closeEditRateModal,
            onSave: updateUserRate
          }, null, 8, ["userName", "existingRates", "rules"])]),
          _: 1
        }, 8, ["modelValue"])) : _createCommentVNode("", true), _createVNode(LlConfirmationDialog, {
          showWarningIcon: true,
          ref_key: "zeroRateAlert",
          ref: zeroRateAlert,
          title: "",
          "confirm-text": "Save Anyway",
          "toggle-text": "Cancel",
          message: `Note: $0 default rates are not recommended. A user's default rate will be assigned unless another rate is specified. Therefore, a $0 default rate can result in time entries becoming ready to bill or even sent in invoices with $0 rates.`
        }, null, 512), _createVNode(LlConfirmationDialog, {
          showWarningIcon: true,
          ref_key: "confirmationDialog",
          ref: confirmationDialog,
          title: dialogOptions.value.title,
          message: dialogOptions.value.message,
          "confirm-text": dialogOptions.value.confirmText,
          "toggle-text": dialogOptions.value.cancelText,
          onConfirm: handleConfirm,
          onCancel: handleCancel
        }, null, 8, ["title", "message", "confirm-text", "toggle-text"]), _createVNode(_component_v_card_title, {
          class: "headline"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(cardTitle.value) + " ", 1), _createVNode(_component_v_icon, {
            class: "float-right font-sm",
            onClick: _cache[1] || (_cache[1] = $event => emit('cancel'))
          }, {
            default: _withCtx(() => [...(_cache[21] || (_cache[21] = [_createTextVNode("mdi-close", -1)]))]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_v_card_text, null, {
          default: _withCtx(() => [_createVNode(_component_v_form, {
            ref_key: "userForm",
            ref: userForm,
            onSubmit: _withModifiers(save, ["prevent"]),
            modelValue: isFormValid.value,
            "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => isFormValid.value = $event)
          }, {
            default: _withCtx(() => [_createVNode(_component_v_row, null, {
              default: _withCtx(() => [__props.type === 'accountant' ? (_openBlock(), _createBlock(_component_v_col, {
                key: 0,
                cols: "12",
                md: "12"
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_cache[22] || (_cache[22] = _createElementVNode("p", {
                  class: "text-left text-[#77591d]"
                }, " Accountants or bookkeepers that are not part of your firm can be added to LeanLaw for free. Inviting them does not impact your subscription. This role has access to all functions and information in the system, but not able to have time or expenses tracked against them. ", -1)), _createVNode(LlCheckbox, {
                  modelValue: companyUserInfoModal.confirmExternalUser,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => companyUserInfoModal.confirmExternalUser = $event),
                  label: "I confirm that this user is not part of our firm"
                }, null, 8, ["modelValue"])])]),
                _: 1
              })) : _createCommentVNode("", true), _createVNode(_component_v_col, {
                cols: "12",
                md: "12"
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_cache[23] || (_cache[23] = _createElementVNode("div", {
                  class: "w-3/12 pr-4"
                }, [_createElementVNode("label", {
                  class: "text-left"
                }, "Email")], -1)), _createElementVNode("div", _hoisted_3, [__props.type === 'invite' || __props.type === 'accountant' ? (_openBlock(), _createBlock(LlTextField, {
                  key: 0,
                  "data-cy": "invite-email-input",
                  modelValue: companyUserInfoModal.form.email,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => companyUserInfoModal.form.email = $event),
                  placeholder: "User's email address",
                  type: 'email',
                  hideDetails: false,
                  rules: validationRules.email,
                  label: "",
                  incomingName: 'email'
                }, null, 8, ["modelValue", "rules"])) : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(companyUserInfoModal.form.email), 1))])])]),
                _: 1
              }), _createVNode(_component_v_col, {
                cols: "12",
                md: "12"
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_cache[24] || (_cache[24] = _createElementVNode("div", {
                  class: "w-3/12 pr-4"
                }, [_createElementVNode("label", {
                  class: "text-left"
                }, "First Name")], -1)), _createElementVNode("div", _hoisted_6, [_createVNode(LlTextField, {
                  "data-cy": "first-name-input",
                  incomingName: 'firstname',
                  modelValue: companyUserInfoModal.form.firstName,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => companyUserInfoModal.form.firstName = $event),
                  placeholder: "User's first name",
                  hideDetails: false,
                  rules: [validationRules.required],
                  label: ""
                }, null, 8, ["modelValue", "rules"])])])]),
                _: 1
              }), _createVNode(_component_v_col, {
                cols: "12",
                md: "12"
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_7, [_cache[25] || (_cache[25] = _createElementVNode("div", {
                  class: "w-3/12 pr-4"
                }, [_createElementVNode("label", {
                  class: "text-left"
                }, "Last Name")], -1)), _createElementVNode("div", _hoisted_8, [_createVNode(LlTextField, {
                  "data-cy": "last-name-input",
                  modelValue: companyUserInfoModal.form.lastName,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => companyUserInfoModal.form.lastName = $event),
                  placeholder: "User's last name",
                  hideDetails: false,
                  rules: [validationRules.required],
                  label: "",
                  incomingName: 'lastname'
                }, null, 8, ["modelValue", "rules"])])])]),
                _: 1
              }), companyUserInfoModal.form.role !== 'Accountant' ? (_openBlock(), _createBlock(_component_v_col, {
                key: 1,
                cols: "12",
                md: "12"
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("label", _hoisted_11, [_cache[27] || (_cache[27] = _createTextVNode("Name/Initials for Invoicing ", -1)), _createVNode(LlTooltip, {
                  icon: "help"
                }, {
                  default: _withCtx(() => [...(_cache[26] || (_cache[26] = [_createTextVNode(" By default, the user's full name is used on invoices. You can provide an alternative name for example the initials of the user. ", -1)]))]),
                  _: 1
                })])]), _createElementVNode("div", _hoisted_12, [_createVNode(LlTextField, {
                  modelValue: companyUserInfoModal.form.initials,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => companyUserInfoModal.form.initials = $event),
                  placeholder: fullName.value,
                  hideDetails: false,
                  label: "",
                  incomingName: 'invoicename'
                }, null, 8, ["modelValue", "placeholder"])])])]),
                _: 1
              })) : _createCommentVNode("", true), _unref(companySettings).codes.ledes && companyUserInfoModal.form.role !== 'Accountant' ? (_openBlock(), _createBlock(_component_v_col, {
                key: 2,
                cols: "12",
                md: "12"
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createElementVNode("label", _hoisted_15, [_cache[29] || (_cache[29] = _createTextVNode("Initials for LEDES ", -1)), _createVNode(LlTooltip, {
                  icon: "help"
                }, {
                  default: _withCtx(() => [...(_cache[28] || (_cache[28] = [_createTextVNode(" LEDES files will contain the initials for the user as specified above, but this can be used to override it. It will go in the TIMEKEEPER_ID field ", -1)]))]),
                  _: 1
                })])]), _createElementVNode("div", _hoisted_16, [_createVNode(LlTextField, {
                  modelValue: companyUserInfoModal.form.ledesInitials,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => companyUserInfoModal.form.ledesInitials = $event),
                  incomingName: 'ledesInitials'
                }, null, 8, ["modelValue"])])])]),
                _: 1
              })) : _createCommentVNode("", true), _unref(companySettings).tags?.enabled && companyUserInfoModal.form.role !== 'Accountant' ? (_openBlock(), _createBlock(_component_v_col, {
                key: 3,
                cols: "12",
                md: "12"
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_17, [_cache[30] || (_cache[30] = _createElementVNode("div", {
                  class: "w-3/12 pr-4"
                }, [_createElementVNode("label", {
                  class: "text-left"
                }, "Invoice Class")], -1)), _createElementVNode("div", _hoisted_18, [_createVNode(LlSelect, {
                  modelValue: companyUserInfoModal.form.invoiceClass,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => companyUserInfoModal.form.invoiceClass = $event),
                  items: companyUserInfoModal.invoiceClassTags,
                  "item-title": "label",
                  "item-value": "id",
                  isAutocomplete: "",
                  placeholder: "Select a class for user",
                  variant: 'outlined',
                  "hide-details": "true",
                  labelClass: "text-sm at-choose-client remove-outline",
                  label: ""
                }, null, 8, ["modelValue", "items"])])])]),
                _: 1
              })) : _createCommentVNode("", true), _unref(companySettings).distribution?.account?.id ? (_openBlock(), _createBlock(_component_v_col, {
                key: 4,
                cols: "12",
                md: "12"
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_19, [_cache[31] || (_cache[31] = _createElementVNode("div", {
                  class: "w-3/12 pr-4"
                }, [_createElementVNode("label", {
                  class: "text-left"
                }, "Distribution Category")], -1)), _createElementVNode("div", _hoisted_20, [_createVNode(LlSelect, {
                  modelValue: companyUserInfoModal.form.distributionCategory,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => companyUserInfoModal.form.distributionCategory = $event),
                  items: companyUserInfoModal.accountList,
                  "item-title": "label",
                  "item-value": "id",
                  isAutocomplete: "",
                  placeholder: "Select Distribution Category",
                  variant: 'outlined',
                  "hide-details": "true",
                  labelClass: "text-sm at-choose-client remove-outline",
                  label: "",
                  clearable: true
                }, null, 8, ["modelValue", "items"])])])]),
                _: 1
              })) : _createCommentVNode("", true), __props.type !== 'accountant' && companyUserInfoModal.form.role !== 'Accountant' ? (_openBlock(), _createBlock(_component_v_col, {
                key: 5,
                cols: "12",
                md: "12"
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_createElementVNode("label", _hoisted_23, [_createTextVNode(_toDisplayString(__props.type === 'invite' ? 'Standard Rate' : 'User Rate') + " ", 1), __props.type === 'invite' ? (_openBlock(), _createBlock(LlTooltip, {
                  key: 0,
                  icon: "help"
                }, {
                  default: _withCtx(() => [...(_cache[32] || (_cache[32] = [_createTextVNode(" The user can set up additional non-standard rates under user settings ", -1)]))]),
                  _: 1
                })) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_24, [__props.type === 'invite' ? (_openBlock(), _createBlock(LlTextField, {
                  key: 0,
                  "data-cy": "standard-rate-input",
                  incomingName: 'rate',
                  modelValue: companyUserInfoModal.form.standardRate,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => companyUserInfoModal.form.standardRate = $event),
                  prefix: '$',
                  type: 'number',
                  hideDetails: false,
                  step: _unref(companySettings).timeEntryIncrement || 0.1,
                  min: 0,
                  rules: rateRules.value,
                  label: ""
                }, null, 8, ["modelValue", "step", "rules"])) : (_openBlock(), _createElementBlock("a", {
                  key: 1,
                  class: "cursor-pointer",
                  onClick: _cache[11] || (_cache[11] = $event => companyUserInfoModal.showEditRateModal = true)
                }, "Edit Rate"))])])]),
                _: 1
              })) : _createCommentVNode("", true), companyUserInfoModal.form.role !== 'Accountant' ? (_openBlock(), _createBlock(_component_v_col, {
                key: 6,
                cols: "12",
                md: "12"
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, [_createElementVNode("label", _hoisted_27, [_cache[34] || (_cache[34] = _createTextVNode("Role ", -1)), _createVNode(LlTooltip, {
                  icon: "help"
                }, {
                  default: _withCtx(() => [...(_cache[33] || (_cache[33] = [_createTextVNode(" The default role for the user. Select a role to see a description of it. ", -1)]))]),
                  _: 1
                })])]), _createElementVNode("div", _hoisted_28, [_createVNode(LlSelect, {
                  "data-cy": "role-select",
                  modelValue: companyUserInfoModal.form.role,
                  "onUpdate:modelValue": [_cache[12] || (_cache[12] = $event => companyUserInfoModal.form.role = $event), handleRoleChange],
                  items: companyUserInfoModal.roles,
                  placeholder: 'Select a default role for this user',
                  labelClass: "text-sm at-choose-client remove-outline",
                  rules: [validationRules.required],
                  "item-title": "label",
                  "item-value": "label"
                }, null, 8, ["modelValue", "items", "rules"]), companyUserInfoModal.form.role ? (_openBlock(), _createElementBlock("div", _hoisted_29, _toDisplayString(companyUserInfoModal.roleDescription), 1)) : _createCommentVNode("", true)])])]),
                _: 1
              })) : _createCommentVNode("", true), _unref(features).ledesXml2 && _unref(companySettings).codes.ledes ? (_openBlock(), _createBlock(_component_v_col, {
                key: 7,
                cols: "12",
                md: "12",
                class: "p-0"
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_30, [_cache[35] || (_cache[35] = _createElementVNode("div", {
                  class: "w-3/12 pr-4"
                }, [_createElementVNode("label", {
                  class: "text-left"
                }, "LEDES Timekeeper Classification Codes - 1998B")], -1)), _createElementVNode("div", _hoisted_31, [_createVNode(LlTextField, {
                  modelValue: companyUserInfoModal.form.ledesCode1998B,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => companyUserInfoModal.form.ledesCode1998B = $event),
                  incomingName: 'ledesCode1998B'
                }, null, 8, ["modelValue"])])])]),
                _: 1
              })) : _createCommentVNode("", true), _unref(features).ledesXml2 && _unref(companySettings).codes.ledes ? (_openBlock(), _createBlock(_component_v_col, {
                key: 8,
                cols: "12",
                md: "12",
                class: "p-0"
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_32, [_cache[36] || (_cache[36] = _createElementVNode("div", {
                  class: "w-3/12 pr-4"
                }, [_createElementVNode("label", {
                  class: "text-left"
                }, "LEDES Timekeeper Classification Codes - New")], -1)), _createElementVNode("div", _hoisted_33, [_createVNode(LlTextField, {
                  modelValue: companyUserInfoModal.form.ledesCodeNew,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => companyUserInfoModal.form.ledesCodeNew = $event),
                  incomingName: 'ledesCodeNew'
                }, null, 8, ["modelValue"])])])]),
                _: 1
              })) : _createCommentVNode("", true), _createVNode(_component_v_col, {
                cols: "12",
                md: "12",
                class: "p-0"
              }, {
                default: _withCtx(() => [_createVNode(LlCheckbox, {
                  disabled: _unref(me).id == __props.userInfo.id,
                  modelValue: companyUserInfoModal.form.accessToFirmSetup,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => companyUserInfoModal.form.accessToFirmSetup = $event),
                  label: "Access to Firm Setup",
                  info: "This user has access to setup features for the firm (inviting\n              users etc)"
                }, null, 8, ["disabled", "modelValue"])]),
                _: 1
              }), _createVNode(_component_v_col, {
                cols: "12",
                md: "6",
                class: "p-0"
              }, {
                default: _withCtx(() => [_createVNode(LlCheckbox, {
                  modelValue: companyUserInfoModal.form.ccResponsibleInvoices,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => companyUserInfoModal.form.ccResponsibleInvoices = $event),
                  label: "CC on responsible invoices",
                  info: "If selected, the user will be cc'd on invoices for any matters they are responsible\n                for"
                }, null, 8, ["modelValue"])]),
                _: 1
              }), _createVNode(_component_v_col, {
                cols: "12",
                md: "12",
                class: "p-0"
              }, {
                default: _withCtx(() => [_createVNode(LlCheckbox, {
                  modelValue: companyUserInfoModal.form.includeOnAllMatters,
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => companyUserInfoModal.form.includeOnAllMatters = $event),
                  label: `Include on all ${_unref(terms).matter}s`,
                  info: "If selected, the user will be added automatically to all NEW and EXISTING matters"
                }, null, 8, ["modelValue", "label"])]),
                _: 1
              }), _createVNode(_component_v_col, {
                cols: "12",
                md: "12",
                class: "p-0"
              }, {
                default: _withCtx(() => [_createVNode(LlCheckbox, {
                  modelValue: companyUserInfoModal.form.ccMeOnInvoicesByDefault,
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => companyUserInfoModal.form.ccMeOnInvoicesByDefault = $event),
                  label: 'CC by default on invoices this user sends ',
                  info: "Enabling this settings checks 'Send a copy to\n            me' on by default in the invoice emailing workflow"
                }, null, 8, ["modelValue"])]),
                _: 1
              }), _unref(features).reset ? (_openBlock(), _createBlock(_component_v_col, {
                key: 9,
                cols: "12",
                md: "12",
                class: "p-0"
              }, {
                default: _withCtx(() => [_createVNode(LlSecondaryButton, {
                  onClick: resetPassword
                }, {
                  default: _withCtx(() => [_cache[38] || (_cache[38] = _createTextVNode(" Reinvite User ", -1)), !companyUserInfoModal.isUserInvited ? (_openBlock(), _createBlock(LlTooltip, {
                    key: 0,
                    icon: "help"
                  }, {
                    default: _withCtx(() => [...(_cache[37] || (_cache[37] = [_createTextVNode(" If user is unable to log in for some reason, this will send them a new invitation email ", -1)]))]),
                    _: 1
                  })) : _createCommentVNode("", true)]),
                  _: 1
                })]),
                _: 1
              })) : _createCommentVNode("", true)]),
              _: 1
            })]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_v_card_actions, {
          class: "flex justify-end items-center gap-4 px-5"
        }, {
          default: _withCtx(() => [_createVNode(LlSecondaryButton, {
            "data-cy": "close-modal-button",
            onClick: _cache[20] || (_cache[20] = $event => emit('cancel'))
          }, {
            default: _withCtx(() => [...(_cache[39] || (_cache[39] = [_createTextVNode(" Cancel ", -1)]))]),
            _: 1
          }), !companyUserInfoModal.loading && __props.userInfo.id ? (_openBlock(), _createElementBlock("div", _hoisted_34, [_withDirectives(_createVNode(LlSecondaryButton, {
            color: "error",
            "data-cy": "remove-or-disable-button",
            variant: "flat",
            onClick: disableOrRemoveUser,
            disabled: companyUserInfoModal.subscriptionCostLoading || companyUserInfoModal.isSaving,
            isSaving: companyUserInfoModal.isSaving
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(companyUserInfoModal.accountState.activity ? 'Disable' : 'Remove'), 1)]),
            _: 1
          }, 8, ["disabled", "isSaving"]), [[_vShow, __props.userInfo.id && companyUserInfoModal.selectedUserData?.id !== _unref(me).id && !companyUserInfoModal.selectedUserData.disabled]]), companyUserInfoModal.selectedUserData.disabled ? (_openBlock(), _createBlock(LlSecondaryButton, {
            key: 0,
            onClick: enableUser,
            disabled: companyUserInfoModal.subscriptionCostLoading || companyUserInfoModal.isSaving
          }, {
            default: _withCtx(() => [...(_cache[40] || (_cache[40] = [_createTextVNode(" Enable ", -1)]))]),
            _: 1
          }, 8, ["disabled"])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), companyUserInfoModal.isUserInvited && __props.userInfo.id && !__props.userInfo.disabled ? (_openBlock(), _createBlock(LlSecondaryButton, {
            key: 1,
            onClick: sendInvite
          }, {
            default: _withCtx(() => [...(_cache[41] || (_cache[41] = [_createTextVNode(" Resend Invite ", -1)]))]),
            _: 1
          })) : _createCommentVNode("", true), _createVNode(_component_v_spacer), _createVNode(LlSecondaryButton, {
            color: "primary",
            onClick: save,
            type: "submit",
            disabled: companyUserInfoModal.isSaving || !isFormValid.value,
            isSaving: companyUserInfoModal.isSaving
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.type === 'invite' ? 'Add User and Send Invite' : 'Save'), 1)]),
            _: 1
          }, 8, ["disabled", "isSaving"])]),
          _: 1
        })]),
        _: 1
      }))], 64);
    };
  }
};